module.exports = __webpack_public_path__ + "img/phpAmount.d56f6f7e.png";